export const CURRENCY_META = {
  INR: { symbol: "\u20b9", indian: true },
  USD: { symbol: "$" },
  EUR: { symbol: "\u20ac" },
  GBP: { symbol: "\u00a3" },
  AED: { symbol: "AED " },
  SGD: { symbol: "S$" },
  AUD: { symbol: "A$" },
};

export function formatMoney(minor, currency = "INR") {
  const meta = CURRENCY_META[currency] || CURRENCY_META.USD;
  const neg = minor < 0;
  const abs = Math.abs(Math.round(minor || 0));
  const whole = Math.floor(abs / 100);
  const frac = String(abs % 100).padStart(2, "0");
  let s = String(whole);
  if (meta.indian && s.length > 3) {
    const tail = s.slice(-3);
    let head = s.slice(0, -3);
    const parts = [];
    while (head.length > 2) {
      parts.unshift(head.slice(-2));
      head = head.slice(0, -2);
    }
    if (head) parts.unshift(head);
    s = [...parts, tail].join(",");
  } else {
    s = whole.toLocaleString("en-US");
  }
  return `${neg ? "-" : ""}${meta.symbol}${s}.${frac}`;
}

export function compactMoney(minor, currency = "INR") {
  const meta = CURRENCY_META[currency] || CURRENCY_META.USD;
  const v = Math.round((minor || 0) / 100);
  if (meta.indian) {
    if (v >= 10000000) return `${meta.symbol}${(v / 10000000).toFixed(2)} Cr`;
    if (v >= 100000) return `${meta.symbol}${(v / 100000).toFixed(2)} L`;
  } else {
    if (v >= 1000000) return `${meta.symbol}${(v / 1000000).toFixed(2)}M`;
    if (v >= 1000) return `${meta.symbol}${(v / 1000).toFixed(1)}K`;
  }
  return `${meta.symbol}${v.toLocaleString("en-US")}`;
}

export const STATUS_STYLES = {
  draft: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30",
  sent: "bg-blue-500/15 text-blue-400 border-blue-500/30",
  viewed: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  accepted: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  declined: "bg-red-500/15 text-red-400 border-red-500/30",
  expired: "bg-zinc-500/15 text-zinc-500 border-zinc-500/25",
};

export function lineTotals(line) {
  const gross = Math.round((Number(line.qty) || 0) * (Number(line.unit_price_minor) || 0));
  const discount = Math.round((gross * (Number(line.discount_pct) || 0)) / 100);
  const net = gross - discount;
  const tax = Math.round((net * (Number(line.tax_pct) || 0)) / 100);
  return { gross, discount, net, tax, total: net + tax };
}

export function pricingTotals(lines = [], gstMode = "none") {
  let subtotal = 0,
    discount = 0,
    tax = 0;
  lines.forEach((l) => {
    const t = lineTotals(l);
    subtotal += t.gross;
    discount += t.discount;
    tax += t.tax;
  });
  const net = subtotal - discount;
  let breakdown = {};
  if (gstMode === "cgst_sgst") {
    const half = Math.floor(tax / 2);
    breakdown = { CGST: half, SGST: tax - half };
  } else if (gstMode === "igst") breakdown = { IGST: tax };
  else if (gstMode === "single") breakdown = { GST: tax };
  return { subtotal, discount, net, tax, breakdown, total: net + tax };
}

export function relative(iso) {
  if (!iso) return "\u2014";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)}d ago`;
  return new Date(iso).toLocaleDateString();
}
